// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__30GbR","icon":"SortAdornment_icon__3RH7B","up":"SortAdornment_up__1To7M","down":"SortAdornment_down__3bl_l","active":"SortAdornment_active__8mEDq"};